import React from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "react-bootstrap";
import constants from "../../utils/contants";

const LogOutModal = () => {

    const navigate = useNavigate();

    const logout = async () => {
        localStorage.removeItem(constants.TOKEN);
        navigate("/login");
        // eslint-disable-next-line react-hooks/exhaustive-deps
    };


    return (
        <div
            id="userModal5"
            className="modal modal-content-scrollable"
            tabIndex={-1}
        >
            <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content ">
                    <div className="modal-header text-black border-0">
                        <h5 className="modal-title">Logout Confirmation</h5>
                    </div>
                    <div className="modal-body">

                        <p className="primary_bg bg-white text-black">
                            Are you sure you want to Logout?
                        </p>

                    </div>
                    <div className="modal-footer border-0 ">
                        <Button
                            variant="secondary"
                            type="button"
                            data-bs-dismiss="modal"
                            id="close__button"
                        >
                            Close
                        </Button>
                        <Button variant="danger" data-bs-dismiss="modal" onClick={logout}>
                            Logout
                        </Button>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default LogOutModal